import React from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import Orders from "./Orders";
import CancelledOrders from "./Orders/CancelledOrders";
import OrderDetail from "./OrderDetail";
import Login from "./Login";
import Review from "./Review";
import PersonalData from "./Agreements/PersonalData";

import { Roles } from "./config";

const useStyles = makeStyles(() => ({
  container: {
    maxWidth: "100%",
    padding: "16px",
  },
  copyright: {
    marginTop: "30px",
  },
}));

function Copyright() {
  const classes = useStyles();

  return (
    <Typography
      variant="body2"
      color="textSecondary"
      align="center"
      className={classes.copyright}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://getir.com/" target="_blank">
        Getir
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export default function App() {
  const classes = useStyles();

  const isAuth = !!localStorage.getItem("authToken");

  const PublicRoute = ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={(props) =>
        !isAuth ? <Component {...props} /> : <Redirect to="/orders" />
      }
    />
  );

  const PrivateRoute = ({ component: Component, roles, ...rest }) => (
    <Route
      {...rest}
      render={(props) => {
        const isAuth = !!localStorage.getItem("authToken");
        const currentRole = localStorage.getItem("role");

        if (!isAuth) {
          // not logged in so redirect to login page with the return url
          return (
            <Redirect
              to={{ pathname: "/login", state: { from: props.location } }}
            />
          );
        }

        // check if route is restricted by role
        if (roles && roles.indexOf(currentRole) === -1) {
          // role not authorised so redirect to home page
          return <Redirect to={{ pathname: "/orders" }} />;
        }

        // authorised so return component
        return <Component {...props} />;
      }}
    />
  );

  return (
    <Container className={classes.container}>
      <Box my={1}>
        <BrowserRouter>
          <Switch>
            <PublicRoute path="/login" exact component={Login} />
            <Route
              path="/sozlesmeler/kisisel-veriler"
              exact
              component={PersonalData}
            />
            <PrivateRoute
              path="/"
              roles={[Roles.PICKER, Roles.COURIER, Roles.GETIR_MH]}
              exact
              component={Orders}
            />
            <PrivateRoute
              path="/orders"
              roles={[Roles.PICKER, Roles.COURIER, Roles.GETIR_MH]}
              exact
              component={Orders}
            />
            <PrivateRoute
              path="/orders/:orderId"
              roles={[Roles.PICKER, Roles.COURIER, Roles.GETIR_MH]}
              exact
              component={OrderDetail}
            />
            <PrivateRoute
              path="/cancelled-orders"
              roles={[Roles.GETIR_MH]}
              exact
              component={CancelledOrders}
            />
          </Switch>
        </BrowserRouter>
      </Box>
      <Copyright />
    </Container>
  );
}
